import React, { Component,Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import TransHistoryList from './TransHistoryList';
import TransHistoryListLG from './TransHistoryListLG';
@inject('commonStore','transStore')
@observer
class TransHistoryContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.transStore.setCommonStoreInfo(this.props.commonStore);
    this.props.transStore.onClear();
    this.props.transStore.disOrderList(1);
    const { sessionLoginInfo } = this.props.commonStore;
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    
    return (
      <Fragment>
        {
      (sessionLoginInfo !== null && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) &&
        (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG)
        ? <TransHistoryList />
        : <TransHistoryListLG 
        cGbn={(sessionLoginInfo !== null && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) 
          ? sessionLoginInfo.cGbn : ""}
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
    
        />
        }
      </Fragment>
    );
  
  }

}

export default withRouter(TransHistoryContainer);
